/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_StartingInputs */

const en_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting loudness analysis (first pass)...`)
};

const fr_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l'analyse de loudness (premier passage)...`)
};

const de_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautheitsanalyse starten (erster Durchgang)...`)
};

const it_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'analisi del volume (primo passaggio)...`)
};

const ru_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начальный анализ громкости (первый этап)...`)
};

const es_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando el análisis de sonoridad (primer paso)...`)
};

const zh_cn2_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初始响度分析（第一遍）……`)
};

const ja_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウドネス分析 (第 1 パス) を開始しています...`)
};

const hi_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि विश्लेषण शुरू करना (पहला चरण)...`)
};

const pt_pt2_audio_description_export_loudness_starting = /** @type {(inputs: Audio_Description_Export_Loudness_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a análise de sonoridade (primeira passagem)...`)
};

/**
* | output |
* | --- |
* | "Starting loudness analysis (first pass)..." |
*
* @param {Audio_Description_Export_Loudness_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_starting = /** @type {((inputs?: Audio_Description_Export_Loudness_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_starting(inputs)
	if (locale === "de") return de_audio_description_export_loudness_starting(inputs)
	if (locale === "it") return it_audio_description_export_loudness_starting(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_starting(inputs)
	if (locale === "es") return es_audio_description_export_loudness_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_starting(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_starting(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_starting(inputs)
	return en_audio_description_export_loudness_starting(inputs)
});